<template>
    <div class="yh-page">
      <el-card>
        <el-row slot="header" type="flex" justify="space-between" align="middle" class="p-3" :gutter="10">
          <el-col :span="20">
            <el-input placeholder="输入船东信息进行搜索..." v-model.trim="query.search"
                      @keyup.enter.native="handleSearch">
              <el-button slot="append" icon="el-icon-search" v-loading="searching" @click="handleSearch">搜索</el-button>
            </el-input>
          </el-col>
          <el-col :span="4">
              <el-button type="primary" size="small" icon="el-icon-plus" @click="createPermissions">新增权限</el-button>

            &nbsp;&nbsp;
            <!-- <span>
              <el-button type="primary" size="small"  @click="handleCustomerUploadCert">上传证书</el-button>
            </span>
            &nbsp;&nbsp;
            <span>
              <el-button type="primary" size="small"  v-if="$perm(['customer.export_customer_info'])" @click="doExport">导出</el-button>
            </span> -->
          </el-col>
        </el-row>
        <div>
          <el-table :key="0" :data="list" stripe v-loading="listLoading" :element-loading-text="loadingText" fit
                    highlight-current-row class="w-100">
            <!-- 客户名称 -->
            <el-table-column align="left" label="会员名称">
              <template slot-scope="scope">
                <span>{{scope.row.member_name}}</span>
              </template>
            </el-table-column>

            <el-table-column align="left" label="所属部门">
              <template slot-scope="scope">
                <span>{{scope.row.dept}}</span>
              </template>
            </el-table-column>
         
            <!-- 更新人 -->
            <el-table-column align="left" label="创建人">
              <template slot-scope="scope">
                <span>{{scope.row.updater_name ? scope.row.updater_name :scope.row.creator_name}}</span>
              </template>
            </el-table-column>

    
            <el-table-column align="left" label="操作">
              <template slot-scope="scope">
                <el-tooltip class="item" effect="light" content="删除" placement="top-start">
                  <el-button type="text" @click="handleDelete(scope.row)"><i class="el-icon-delete"></i></el-button>
                </el-tooltip>
            
              </template>
            </el-table-column>
          </el-table>
          <pagination-new :size.sync="query.limit" :offset.sync="query.offset" :total="total"
                      @updateList="getList"></pagination-new>
        </div>
      </el-card>

      <el-dialog :visible.sync="permissionsVisible" width="50%">
        <el-form ref="form" :model="form" label-width="120px">
            <el-form-item label="请选择部门" width="50%">
            <el-select v-model="form.department" placeholder="请选择部门" filterable value-key="id"  style="width: 48%;">
                <el-option v-for="g in groupList" :key="g.id"
                    :label="g.name" :value="g.id"></el-option>
            </el-select>
        </el-form-item>
        </el-form>
        <el-form ref="form" :model="form" label-width="120px">
        <el-form-item label="会员信息" prop="customer">
            <el-select v-model="form.member" placeholder="请选择会员"
             filterable @change="handleCustomerInfo" value-key="id"
             remote :remote-method="remoteCustomerMethod" :loading="customer_loading"
            >
              <el-option v-for="c in members" :key="c.id"
                  :label="c.name" :value="c.id"></el-option>
            </el-select>
          </el-form-item>
        </el-form>

        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="addSussess">确 定</el-button>
        </span>
        </el-dialog>
    </div>
  </template>
  
  <script>
    import {parseTime} from '@/utils'
    import PaginationNew from '@/components/PaginationNew'
    import { fetchList as fetchGroupList, fetchGroupMember } from "@/api/group";
    import {distributionPermission,permissionsList,getMemberList,addPermission} from '@/api/member'
  
    export default {
      name: "permissionsList",
      components: {
        PaginationNew,
      },
      filters: {
        parseTime
      },
      data() {
        return {
          list:[],
          groupList:[],
          members:[],
          query: {
            search: '',
            offset: 0,
            limit: 20
          },
          form:{},
          searching: false,
          listLoading: false,
          loadingText: '正在加载船东数据，请稍等...',
          permissionsVisible:false,
          customer_loading: false,
          list: [],
          total: 0,
        }
      },
      methods: {
        handleCustomerInfo(){},

        remoteCustomerMethod(query) {
        if (query !== '') {
          this.customer_loading = true
          setTimeout(() => {
            getMemberList({'search': query,'status':1}).then(res => {
              this.members = res
              this.customer_loading = false
            }).catch(err => {
              this.customer_loading = false
              this.$error_message(err)
            })
          }, 200);
            } else {
            this.customers = [];
            }
        },
        addSussess(){
            addPermission(this.form).then(res => {
                this.getList()
                this.$message({
                type: 'success',
                message: '创建成功!'
                })
                this.permissionsVisible = false
            })
            .catch((error) => {
              this.listLoading = false
              this.$error_message(error)
            })
        },

        createPermissions(){
            this.permissionsVisible = true
            this.loadData()
        },

        loadData() {
            this.loading = true
            let p = []
            p.push(fetchGroupList())
            Promise.all(p)
            .then(res => {
            this.groupList = res[0]
            })
            .catch(err => {
            this.loading = false
            this.$error_message(err)
            })
        },

        handleDelete(row){

        var msg = '是否删除' + row.dept +  '对会员' + row.member_name + ' 的权限？'
        this.$confirm(msg, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'info'
        }).then(() => {
            distributionPermission({"id":row.id})
            .then(res => {
                this.$message({
                type: 'success',
                message: '删除成功!'
                })
                this.getList()
            })
            .catch((error) => { 
            this.$error_message(error)
            })
            })  
        },
   
        setQueryStorage() {
            window.localStorage.setItem('query', JSON.stringify(this.query))
          },
        handleSearch() {
          this.getList()
        },
        getList() {
          // 从数据库中加载用户数据
          this.listLoading = true
          permissionsList(this.query)
            .then(res => {
              this.list = res.results
              this.total = res.count
              this.listLoading = false
            })
            .catch((error) => {
              this.listLoading = false
              this.$error_message(error)
            })
        },
      },
      created() {
        this.getList()
      }
    }
  </script>
  